(() => {
    if (window.__pbCartFastV1) return;
    window.__pbCartFastV1 = true;

    const CART_SECTION = 'r_cart';
    const NOTIFICATION_SECTION = 'r_cart-notification';
    const PRODUCT_CACHE = new Map();

    const positive = (value) => {
        const parsed = Number.parseInt(String(value ?? '').replace(/[^\d]/g, ''), 10);
        return Number.isInteger(parsed) && parsed > 0 ? parsed : null;
    };

    const sameProperties = (left = {}, right = {}) => {
        const leftEntries = Object.entries(left).filter(([, value]) => value !== null && value !== '');
        const rightEntries = Object.entries(right).filter(([, value]) => value !== null && value !== '');
        if (leftEntries.length !== rightEntries.length) return false;
        return leftEntries.every(([key, value]) => String(right[key] ?? '') === String(value));
    };

    const install = (attempt = 0) => {
        const Provider = customElements.get('cart-provider');
        const prototype = Provider?.prototype;

        if (!prototype?.__pbCartRangesV3) {
            if (attempt < 80) window.setTimeout(() => install(attempt + 1), 25);
            return;
        }
        if (prototype.__pbCartFastV1) return;
        prototype.__pbCartFastV1 = true;

        const nativeProduct = prototype._pbProduct;

        prototype._pbProduct = function cachedProduct(line) {
            const cacheKey = String(line?.product_id ?? line?.handle ?? line?.url ?? '');
            if (!cacheKey) return nativeProduct.call(this, line);
            if (!PRODUCT_CACHE.has(cacheKey)) {
                const request = Promise.resolve(nativeProduct.call(this, line)).catch((error) => {
                    PRODUCT_CACHE.delete(cacheKey);
                    throw error;
                });
                PRODUCT_CACHE.set(cacheKey, request);
            }
            return PRODUCT_CACHE.get(cacheKey);
        };

        prototype._pbConverge = async function fastConverge(item) {
            const quantity = positive(item.quantity);
            if (!quantity) throw new Error('La cantidad configurada no es válida.');

            const context = this._pbContext(item);
            let cart = await this._pbCart();
            let lines = this._pbLines(cart, context);
            let target = this._pbTarget(lines, item.id, item.properties);

            if (!target) {
                await this._pbRequest('cartAdd', { items: [item] });
                cart = await this._pbCart();
                lines = this._pbLines(cart, context);
                target = this._pbTarget(lines, item.id, item.properties);
            } else {
                const sellingPlan = String(item.selling_plan || '');
                const currentSellingPlan = String(target.selling_plan_allocation?.selling_plan?.id || '');
                const needsChange = Number(target.quantity) !== quantity
                    || !sameProperties(target.properties, item.properties)
                    || currentSellingPlan !== sellingPlan;

                if (needsChange) {
                    cart = await this._pbChange(
                        target.key,
                        quantity,
                        item.properties,
                        item.selling_plan
                    );
                    lines = this._pbLines(cart, context);
                    target = this._pbTarget(lines, item.id, item.properties);
                }
            }

            if (!target) throw new Error('No se pudo crear la selección configurada.');

            for (let guard = 0; guard < 20; guard += 1) {
                lines = this._pbLines(cart, context);
                target = this._pbTarget(lines, item.id, item.properties);
                if (!target) throw new Error('No se pudo confirmar la selección configurada.');

                const duplicate = lines.find((line) => line.key !== target.key);
                if (!duplicate) return { cart, target, context };

                cart = await this._pbChange(duplicate.key, 0);
            }

            throw new Error('No fue posible consolidar las líneas duplicadas.');
        };

        prototype._pbRender = async function fastRender(result, notificationIds = [], notification = false) {
            const sections = [];
            if (this.features.cart) sections.push(CART_SECTION);
            if (notification && this.features.notification) sections.push(NOTIFICATION_SECTION);

            const body = {};
            if (notification && this.features.notification) {
                body.attributes = {
                    notification_items_variant_ids: notificationIds.join(',')
                };
            }
            if (sections.length) {
                body.sections = sections;
                body.sections_url = '/cart';
            }

            let cartData = result.cart;
            if (Object.keys(body).length) {
                cartData = await this._pbRequest('cartUpdate', body);
            }

            this._cleanCartAttributes();
            return cartData;
        };
    };

    if (customElements.get('cart-provider')) {
        install();
    } else {
        customElements.whenDefined('cart-provider').then(() => install());
    }
})();
